import { API_URL } from '../../../../utils/config';

export const GET_DEDICATED_CUSTOMER_BY_AP_URL = `${API_URL}/dedicated/customers`;
export const GET_DEDICATED_CUSTOMER_BY_NAME_URL = `${API_URL}/dedicated/searchByName`;
export const GET_DEDICATED_CUSTOMERS_URL = `${API_URL}/dedicated/customers/1`;
export const GET_PAGINATED_DEDICATED_CUSTOMERS_URL = `${API_URL}/dedicated/customers`;
